import React from 'react';
import {
  CardContainer,
  Background,
  Card,
  TextInput,
  Text,
  Form,
  InputLabel,
  Button,
} from '@design-system/';
import { useSelector, useDispatch } from 'react-redux';
import { getLoading } from './redux/selectors';
import { reset_password } from './redux/reducer';
import { useLocation } from 'react-router-dom';
import * as Yup from 'yup';
import { useFormik } from 'formik';

function useQuery() {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}

const ChangePassword = () => {
  const loading = useSelector(getLoading);
  const dispatch = useDispatch();
  const query = useQuery();

  const formik = useFormik({
    initialValues: {
      email: query.get('email'),
      new_password: '',
      confirm_password: '',
      token: '',
    },
    onSubmit: async (data) => {
      dispatch(reset_password(data));
    },

    validationSchema: Yup.object({
      new_password: Yup.string().required('Password is required.'),
      confirm_password: Yup.string().oneOf(
        [Yup.ref('new_password'), null],
        'Passwords must match',
      ),
      token: Yup.string().required('Token is required.'),
    }),
  });

  return (
    <Background>
      <CardContainer>
        <Card style={{ paddingBottom: 120 }}>
          <Text size="large">Change password</Text>
          <Text size="small">
            Reset your password with the token sent to your email
          </Text>
          <Form onSubmit={formik.handleSubmit}>
            <InputLabel htmlFor="email">Email</InputLabel>
            <TextInput
              name="email"
              type="email"
              id="email"
              placeholder="*********"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.email}
            ></TextInput>
            {formik.touched.email && formik.errors.email ? (
              <Text color="red" align="left">
                {formik.errors.email}
              </Text>
            ) : null}

            <InputLabel htmlFor="token">OTP</InputLabel>
            <TextInput
              type="text"
              id="token"
              name="token"
              placeholder="00000"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.token}
            ></TextInput>
            {formik.touched.token && formik.errors.token ? (
              <Text color="red" align="left">
                {formik.errors.token}
              </Text>
            ) : null}

            <InputLabel htmlFor="password">New Password</InputLabel>
            <TextInput
              name="new_password"
              type="password"
              id="password"
              placeholder="*********"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.new_password}
            ></TextInput>
            {formik.touched.new_password && formik.errors.new_password ? (
              <Text color="red" align="left">
                {formik.errors.new_password}
              </Text>
            ) : null}

            <InputLabel htmlFor="confirm-password" style={{ marginTop: 10 }}>
              Confirm Password
            </InputLabel>
            <TextInput
              name="confirm_password"
              type="password"
              id="confirm-password"
              placeholder="*********"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.confirm_password}
            ></TextInput>
            {formik.touched.confirm_password && formik.errors.confirm_password ? (
              <Text color="red" align="left">
                {formik.errors.confirm_password}
              </Text>
            ) : null}

            <Button
              style={{ marginTop: 30 }}
              text={loading ? 'Resetting...' : 'Reset'}
              type="submit"
            />
          </Form>
        </Card>
      </CardContainer>
    </Background>
  );
};
export default ChangePassword;
